import { Tag as AntTag } from 'antd';
import { TagProps } from 'antd/lib/tag';
import React from 'react';
import './style.scss'; // Global variant classes

export type TagVariant =
    | 'brand-red'
    | 'brand-blue'
    | 'greek-blue'
    | 'success'
    | 'error'
    | 'gold'
    | 'lime'
    | 'orange'
    | 'purple'
    | 'volcano'
    | 'magenta'
    | 'grey'
    | 'blue';

export interface TagComponentProps extends Omit<TagProps, 'color'> {
    variant?: TagVariant;
    children: React.ReactNode;
}

export function Tag({ variant, children, ...antProps }: TagComponentProps) {
    const variantClass = variant ? `tag_${variant.replace(/-/g, '_')}` : '';

    return (
        <AntTag className={variantClass} {...antProps}>
            {children}
        </AntTag>
    );
}
